import React, { useState } from "react";
import CustomURL from "./CustomURL";
import Subscription from "./Subscription";
import Logo from "../../../images/SW-Logo-White.svg";
import BreadCrumbs from "../BreadCrumbs/BreadCrumbs";

const SubdomainAndSubscriptionPage: React.FC = () => {
  let freeTrialUserData:any = localStorage.getItem('freeTrialUserData')
  let freeTrialUserParsedData = JSON.parse(freeTrialUserData)
  const [input, setInput] = useState<string>((freeTrialUserParsedData && freeTrialUserData.hasOwnProperty('domain')) ? freeTrialUserParsedData.domain : '');
  const [error, setError] = useState<string>('')
  const [isAvailable, setIsAvailable] = useState<boolean>()
  const breadCrumbSteps = [
    "Company and Contact Information",
    "Subdomain and Subscription",
  ]
  
  return (
    <div className="subdomain-and-subscription__wrapper">
      <div className="subdomain-and-subscription">
        <header>
          <div className="trial-started__logo-wrapper">
            <img src={Logo} alt='logo' />
          </div>
          <h3>Already a member? <a href={`${process.env.REACT_APP_LOGIN_URL}/login`}>Login</a></h3>
        </header>
        <div className="subdomain-and-subscription__body">
          <div className="subdomain-and-subscription__form-box-wrapper">
            <BreadCrumbs steps={breadCrumbSteps} />
            <div className="subdomain-and-subscription__form-box">
              <CustomURL input={input} setInput={setInput} isAvailable={isAvailable} setIsAvailable={setIsAvailable}/>
              <Subscription domainInput={input} error={error} setError={setError} isAvailable={isAvailable}/>
            </div>
          </div>          
        </div>
      </div>
    </div>
  );
};

export default SubdomainAndSubscriptionPage;
